package com.macrofocus.eflux.ui

import emotion.react.css
import i18next.useTranslation
import mui.material.TooltipPlacement
import mui.material.styles.Theme
import mui.system.SxProps
import react.FC
import react.PropsWithChildren
import react.ReactNode
import react.dom.events.MouseEventHandler
import react.dom.html.ReactHTML
import web.cssom.MarginLeft
import web.html.HTMLImageElement

external interface LogoProps : PropsWithChildren,mui.system.PropsWithSx {
    var version: String
    var logo: String
    var height: Double?
    var marginLeft: MarginLeft?
    var onClick: MouseEventHandler<HTMLImageElement>?
    override var sx: SxProps<Theme>?
}

val Logo = FC<LogoProps> { props ->
    val (t, _) = useTranslation()

    mui.material.Tooltip {
        title = ReactNode("Version ${props.version}")
        placement = TooltipPlacement.right

        ReactHTML.img {
            if(props.marginLeft != null) {
                css {
                    marginLeft = props.marginLeft
                }
            }
            src = props.logo
            height = if(props.height != null) props.height else 36.0
            onClick = props.onClick
        }
    }
}